import { render, staticRenderFns } from "./GroupInfoColumn.vue?vue&type=template&id=4d844243&scoped=true&"
import script from "./GroupInfoColumn.vue?vue&type=script&lang=js&"
export * from "./GroupInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./GroupInfoColumn.vue?vue&type=style&index=0&id=4d844243&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d844243",
  null
  
)

export default component.exports